<template>
  <div>
    <!-- その他課金マスタ -->
    <v-container>
      <v-card class="selectTitle" flat>
        <v-row>
          <v-col cols="1">
            <div class="title_building_name">物件名</div>
          </v-col>
          <v-col cols="3">
            <ryou-select
              v-model="selectBuild"
              :value="selectBuild"
              :items="buildItems"
              :itemText="'building_name'"
              :itemValue="'building_id'"
            >
            </ryou-select>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
    <v-container>
      <v-card flat>
        <v-form
          ref="tableForm"
          v-model="tableForm"
          lazy-validation
          @submit.prevent
        >
          <ryou-table
            ref="ryouTable"
            :rowKey="rowKey"
            :headers="headers"
            :queryParams="queryParams"
            :url="url"
            :autoLoad="false"
            :businessKey="businessKey"
            :dummy="false"
            :needSearch="true"
            :height="height"
            :showSelect="false"
            :handleEdit="handleEdit"
            :handleDelete="handleDelete"
          >
            <v-row slot="filterContainer">
              <v-col class="proAddBtn" cols="12">
                <ryou-blue-btn :label="'新規追加'" :handlerClick="handleAdd">
                </ryou-blue-btn>
              </v-col>
            </v-row>
          </ryou-table>
        </v-form>
      </v-card>
      <MasterOtherCostDialog
        ref="modalForm"
        @ok="modalFormOk"
        :url="url"
      ></MasterOtherCostDialog>
      <ryou-confirm ref="confirm"></ryou-confirm>
    </v-container>
  </div>
</template>

<script>
import RyouTable from "@/components/table/RyouTable.vue";
import RyouSelect from "@/components/formInput/RyouSelect.vue";
import RyouBlueBtn from "@/components/formInput/RyouBlueBtn.vue";
import { RyouTableMixins } from "@/mixins/RyouTableMixins";
import RyouConfirm from "@/components/dialog/RyouConfirm.vue";
import MasterOtherCostDialog from "./modules/MasterOtherCostDialog.vue";

export default {
  name: "MasterOtherBill",
  mixins: [RyouTableMixins],

  components: {
    RyouSelect,
    RyouBlueBtn,
    RyouTable,
    MasterOtherCostDialog,
    RyouConfirm,
  },

  mounted() {},

  data() {
    return {
      tableForm: true,
      rowKey: "rowIndex",
      businessKey: "billing_seq_no",
      selectBuildName: [],
      buildSelect: "",
      selectBuild: 0,
      buildItems: [],
      height: 600,
      headers: [
        {
          text: "No",
          value: "billing_seq_no",
          class: "blue lighten-2 title",
          width: "10%",
          align: "start",
          sortable: true,
          groupable: false,
        },
        {
          text: "物件名",
          value: "building_name",
          width: "20%",
          align: "start",
          sortable: true,
          groupable: false,
        },
        {
          text: "課金区分",
          value: "billing_name",
          width: "30%",
          align: "start",
          sortable: false,
          groupable: false,
        },
        {
          text: "課金代",
          value: "billing_fee",
          width: "20%",
          align: "start",
          sortable: true,
          groupable: false,
        },
        {
          text: "操作",
          class: "blue lighten-2 title",
          value: "actions",
          align: "center",
          sortable: false,
          groupable: false,
        },
        {
          text: "",
          value: "building_id",
          width: "1px",
          type: "hidden",
          sortable: false,
          groupable: false,
        },
      ],
      queryParams: {
        buildingId: 0,
      },
      url: {
        list: "/masterBilling/otherCostGet",
        update: "/masterBilling/otherCostUpdate",
        delete: "/masterBilling/otherCostDelete",
      },
    };
  },

  created() {
    this.initData();
  },

  watch: {
    selectBuild() {
      this.callLoadData();
    },
  },

  methods: {
    initData() {
      let params = {
        userId: this.$store.getters.getUserId,
        userClass: this.$store.getters.getUserClass,
      };
      this.getRequest(
        "/masterRoom/buildingGet",
        params,
        this.$store.getters.getUserToken
      ).then((data) => {
        if (data.success) {
          this.buildItems = data.result; //物件データ
          this.selectBuild = data.result[0].building_id; //物件ID
        }
      });
      setTimeout(() => {}, 100);
    },

    callLoadData() {
      if (this.selectBuild != "") {
        this.queryParams.buildingId = this.selectBuild;
        for (let i = 0; i < this.buildItems.length; i++) {
          if (this.selectBuild === this.buildItems[i].building_id) {
            this.selectBuildName["building_name"] =
              this.buildItems[i].building_name;
            this.selectBuildName["building_id"] = this.selectBuild;
          }
        }
        this.$refs.ryouTable.loadData();
      }
    },

    handleAdd() {
      this.$refs.modalForm.add(this.selectBuildName);
    },
  },
};
</script>

<style scoped>
.selectTitle {
  border-radius: 0%;
  margin: 20px;
}

.title_building_name {
  font-size: 19px;
  padding-top: 10px;
  padding-bottom: 10px;
  text-align: center;
}
</style>
